import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef968cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "input-group"
}
const _hoisted_4 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_5 = ["required", "disabled", "placeholder", "name", "value", "readonly"]
const _hoisted_6 = ["required", "disabled", "placeholder", "name", "value", "readonly"]
const _hoisted_7 = {
  key: 2,
  class: "fv-plugins-message-container invalid-feedback"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTooltip = _resolveComponent("InfoTooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass(["fs-5 fw-semibold mb-2", _ctx.required && 'required']),
            innerHTML: _ctx.label
          }, null, 10, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(_component_InfoTooltip, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "tooltip", {}, undefined, true)
        ]),
        _: 3
      })
    ]),
    (_ctx.inlineIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.inlineIcon)
            ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                _createElementVNode("i", {
                  class: _normalizeClass(_ctx.inlineIcon)
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control form-control-solid", {required: _ctx.required, 'is-invalid': _ctx.errors.length}]),
            required: _ctx.required,
            disabled: _ctx.disabled,
            placeholder: _ctx.placeholder,
            name: _ctx.name,
            value: _ctx.modelValue,
            readonly: _ctx.readonly,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
          }, null, 42, _hoisted_5)
        ]))
      : (_openBlock(), _createElementBlock("input", {
          key: 1,
          type: "text",
          class: _normalizeClass(["form-control form-control-solid", {required: _ctx.required, 'is-invalid': _ctx.errors.length}]),
          required: _ctx.required,
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          name: _ctx.name,
          value: _ctx.modelValue,
          readonly: _ctx.readonly,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
        }, null, 42, _hoisted_6)),
    (_ctx.errors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, i) => {
            return (_openBlock(), _createElementBlock("span", { key: i }, [
              _createTextVNode(_toDisplayString(error) + " ", 1),
              _hoisted_8
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}